// extracted by mini-css-extract-plugin
export default {"container":"ShowcaseHome_container__CR8NI","ShowcaseHome":"ShowcaseHome_ShowcaseHome__0CKd9","ShowcaseBody":"ShowcaseHome_ShowcaseBody__p9F1d"};